import type { Partner } from "@expert/shared-types";

import { useVerifiedCustomerStore } from "@expert/sales-tools";

import { SaleProgress } from "@/sales-tools/home-product/types";

import { ATTIcon, VerizonIcon } from "./icons";
import { OptimumIcon } from "./icons/OptimumIcon";
import classes from "./PlanCard.module.css";

export function determineCardStyle(saleProgress: SaleProgress | undefined) {
    if (saleProgress === SaleProgress.Success) {
        return classes.enrolled;
    } else if (saleProgress === SaleProgress.Declined) {
        return classes.declined;
    }
}

export function getPartnerIcon(partner: string) {
    switch (partner) {
        case "verizon":
        case "fios":
            return <VerizonIcon />;
        case "att":
            return <ATTIcon />;
        case "optimum":
            return <OptimumIcon />;
        default:
            return null;
    }
}

export function showRecommended(partner: Partner, productSku: string, sessionId: string) {
    if (partner !== "youtubetv") return true;

    // YouTube TV specific logic
    const { customer } = useVerifiedCustomerStore.getState().getVerifiedCustomer(sessionId);
    const currentSubscriptions = customer?.currentSubscriptions;
    const hasYouTubeTV = currentSubscriptions?.includes("YouTube TV");
    const hasNFLSundayTicket = currentSubscriptions?.includes("NFL Sunday Ticket");

    return (hasYouTubeTV && hasNFLSundayTicket) || !(productSku === "STREAMING" || productSku === "GOOG_SUNDAYTICKET");
}
